import { render } from "./ActivityDetail.vue?vue&type=template&id=6fcb32ed&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import "./ActivityDetail.vue?vue&type=style&index=0&id=6fcb32ed&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcb32ed"]])

export default __exports__